import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { Cliente } from '../../../core/modelos/cliente';

@Injectable()
export class ClientesService {

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getClientes(): Observable<any> {
        return this.http.get(environment.urlBase + 'clientes', this.constantes.httpOptions);
    }

    getCliente(id: number): Observable<any> {
        return this.http.get(environment.urlBase + 'clientes/' + id, this.constantes.httpOptions);
    }

    updateCliente(cliente: Cliente): Observable<any> {
        return this.http.put(environment.urlBase + 'clientes/' + cliente.id, cliente, this.constantes.httpOptions);
    }

    addCliente(cliente: Cliente): Observable<any> {
        return this.http.post<Cliente>(environment.urlBase + 'clientes', cliente, this.constantes.httpOptions);
    }

    deleteCliente (id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'clientes/' + id, this.constantes.httpOptions);
    }

    adminCambiarCliente(clienteId: number): Observable<any> {
        return this.http.post<Cliente>(environment.urlBase + 'adminCambiarCliente', { cliente_id: clienteId }, this.constantes.httpOptions);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/clientes/clientes.service.ts